// src/utils/api.js


export const getApiUrl = (path) => {
 // Always point to backend on port 5000 in development
 // In production (served via Nginx), use relative paths so Nginx proxies to backend
 if (process.env.NODE_ENV === "development") {
   return `http://localhost:5000${path}`;
 }
  // Check if we're running in Docker (port 3000) but not in production mode
 // This handles the case where frontend Docker container needs to reach backend
 if (window.location.port === "3000") {
   return `http://localhost:5000${path}`;
 }
  return path;
};


export const getFetchOptions = (options = {}) => {
 const { headers = {}, ...otherOptions } = options;
 return {
   headers: {
     "Content-Type": "application/json",
     ...headers,
   },
   ...otherOptions,
 };
};